import React, { useState, useEffect } from 'react';

export default function LoginView({ onSuccess }) {
  const [code, setCode] = useState("");
  const [loginHint, setLoginHint] = useState("");

  useEffect(() => {
    fetch('https://quizapi.steilpass-fussballjobs.de/api/hints/start')
      .then(res => res.json())
      .then(data => setLoginHint(data.content))
      .catch(err => console.error('Fehler beim Laden des Login-Hints:', err));
  }, []);

  return (
    <div className="container text-center py-5" style={{ maxWidth: '600px' }}>
      
      {/* Hint-Text aus der Datenbank */}
      <div className="text-start mb-3" dangerouslySetInnerHTML={{ __html: loginHint }} />

      <input
        className="form-control text-center my-3"
        placeholder="Dein Login-Code"
        value={code}
        onChange={e => setCode(e.target.value)}
      />

      <button className="btn btn-primary w-100" onClick={() => onSuccess(code)}>
        Jetzt teilnehmen!
      </button>
    </div>
  );
}
